import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const PackageCard = () => {
  const navigate = useNavigate(); // Gunakan useNavigate untuk navigasi
  // State untuk melacak apakah tombol sudah diklik
  const [isClicked, setIsClicked] = useState(false);

  // Fungsi untuk navigasi ke halaman /about dan scroll ke elemen dengan ID 'testimoni'
  const handleClick = () => {
    // Menandai bahwa tombol sudah diklik
    setIsClicked(true);

    navigate('/PaketPerjalanan');

    // Scroll ke elemen dengan ID 'testimoni' setelah navigasi
    setTimeout(() => {
      const element = document.getElementById('paket-haji');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' }); // Melakukan scroll ke elemen testimoni
      }
      setIsClicked(false); // Reset state jika perlu
    }, 0); // Pastikan scroll terjadi setelah navigasi
  };

  return (
    <section
      id="package-card"
      className="d-flex align-items-center justify-content-center"
      style={{ height: '100vh' }}
    >
      <div className="package-card d-flex flex-column align-items-center justify-content-center text-center">
        <div className="package-card-content">
          <h1>SANEMA TOUR</h1>
          <h3>
            Mari Wujudkan, <br /> Ibadah ke Baitullah <br /> dengan Mudah dan
            Nyaman Bersama
          </h3>
        </div>
        <Link to="/PaketPerjalanan">
          <button className="btn package-card-button" onClick={handleClick}>
            Lihat Paket Perjalanan
          </button>
        </Link>
      </div>
    </section>
  );
};

export default PackageCard;
